module.exports = __webpack_public_path__ + "static/img/bgRoll2.e9e93fd1.png";